module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "noMargin serviceFormHeader"
  }, [(_vm.objAuthorize.privileges.indexOf('CREATE_EDIT_DELETE_ROLE') !== -1) ? _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "pageTitle"
  }, [_c('h2', [_vm._v("DEPARTMENTAL SERVICE FORMS")]), _vm._v(" "), _c('v-flex', {
    staticStyle: {
      "padding": "12px"
    },
    attrs: {
      "lg12": ""
    }
  }, [_c('div', {
    staticClass: "screenTip"
  }, [_c('span', [_c('i', {
    staticClass: "material-icons infoIcon",
    staticStyle: {
      "width": "30px"
    },
    attrs: {
      "slot": "activator"
    },
    slot: "activator"
  }, [_vm._v("information")]), _vm._v(" This page is used to create additional service forms for departments.\n              The service form link is created by Builders Warehouse - all you need to do is provide them with the Process ID.\n                    ")])])])], 1), _vm._v(" "), (_vm.fncCanDo()) ? _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncProcessAdd.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons"
  }, [_vm._v("add")]), _vm._v("Create Departmental Service Form")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "elevation-5",
    attrs: {
      "color": "info"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.fncReloadDepartments.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "material-icons reloadButton"
  }, [_vm._v("refresh")])])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "lg9": ""
    }
  })], 1) : _vm._e()], 1)
},staticRenderFns: []}